import React from "react";
import { Helmet } from "react-helmet-async";
import "./SocialMediaManagement.css";


// Import service images
import HeroImg from "../assets/social-media-hero.jpeg";


const SocialMediaManagement = () => {

  
  const handleCTAClick = () => {
    if (window.gtag) {
      window.gtag("event", "click", {
        event_category: "CTA",
        event_label: "WhatsApp CTA - Social Media",
        value: 1,
      });
    }
  };

  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>Social Media Management Services in Kenya | Grow Your Business Online</title>

<link rel="canonical" href="https://satimatechnova.co.ke/social-media-management-services/" />

        <meta
          name="description"
          content="Professional social media management services in Kenya including content creation, posting, engagement, and paid ads to help businesses grow and attract customers."
        />

        <meta
          name="keywords"
          content="social media management Kenya, social media marketing Kenya, Facebook marketing Kenya, Instagram marketing Kenya, paid ads Kenya, content creation Kenya, Satima Technova Solutions"
        />

        <meta name="author" content="Satima Technova" />

        {/* Open Graph */}
        <meta property="og:title" content="Social Media Management Services in Kenya" />
        <meta property="og:description" content="Grow your business with expert social media management and marketing strategies in Kenya." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://satimatechnova.co.ke/social-media-management-services/" />


        <script type="application/ld+json">
{JSON.stringify({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "How much does social media management cost?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We offer flexible monthly social media management packages designed for businesses with different goals and budgets. Our Basic Package starts from KSh 6,000 per month, while our Premium Package starts from KSh 12,000 per month. We can also recommend a customized social media strategy based on your business objectives and growth targets."
      }
    },
    {
      "@type": "Question",
      "name": "What platforms do you manage?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We manage popular platforms including Facebook, Instagram, LinkedIn, and other social media channels depending on where your target audience spends their time."
      }
    },
    {
      "@type": "Question",
      "name": "What is included in your social media management service?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our social media management services may include content planning, graphic design, captions, post scheduling, audience engagement, page optimization, performance tracking, and ongoing strategy improvement."
      }
    },
    {
      "@type": "Question",
      "name": "How often will you post on my social media pages?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Posting frequency depends on your selected package and business goals. We create a consistent content schedule designed to keep your audience engaged while maintaining quality and brand consistency."
      }
    },
    {
      "@type": "Question",
      "name": "Do you also manage Facebook and Instagram advertising?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. We create and manage Facebook and Instagram advertising campaigns designed to increase reach, generate leads, promote your services, and help your business reach potential customers."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to see social media results?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Results depend on your industry, audience, content strategy, and advertising budget. While paid campaigns can generate results quickly, consistent organic growth requires ongoing strategy and optimization."
      }
    },
    {
      "@type": "Question",
      "name": "How do I get started with social media management?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Simply contact Satima Technova Solutions for a consultation. We will understand your business, review your current online presence, and recommend the best social media strategy for your goals."
      }
    }
  ]
})}
</script>



      </Helmet>

      <main className="smm-page">

        {/* TRUST SCROLLING BAR */}
<section className="smm-trust-scroll">

  <div className="smm-trust-track">

    <div className="smm-trust-content">

      <span>✓ Professional Content Creation</span>

      <span>✓ Strategic Social Media Growth</span>

      <span>✓ Audience Engagement</span>

      <span>✓ Performance Tracking</span>

    </div>


    {/* Duplicate for seamless scrolling */}

    <div className="smm-trust-content">

      <span>✓ Professional Content Creation</span>

      <span>✓ Strategic Social Media Growth</span>

      <span>✓ Audience Engagement</span>

      <span>✓ Performance Tracking</span>

    </div>

  </div>

</section>



        {/* HERO SECTION */}

<section
  className="smm-hero-section"
  style={{
    backgroundImage: `url(${HeroImg})`
  }}
>
  <div className="smm-hero-overlay">

    <div className="smm-hero-wrapper">

      <div className="smm-hero-text">

        {/* SEO H1 - Hidden Visually */}

        <h1 className="smm-seo-heading">
          Social Media Management Services in Kenya That Drive Real Results
        </h1>


        {/* HERO CONTENT */}

        <div className="smm-intro-content">

          <span className="smm-hero-tag">
            SOCIAL MEDIA MANAGEMENT
          </span>

          <h2>
            Social Media
            <br />
            <span>With Direction.</span>
          </h2>

          <p className="smm-intro-line">
            We help businesses build stronger brands, engage the right
            audience, and turn social media attention into real business growth.
          </p>

        </div>


        {/* HERO ACTION */}

        <a
          href="https://wa.me/254775137928?text=Hi%20Satima%20Technova,%20I%E2%80%99m%20interested%20in%20your%20social%20media%20management%20services."
          target="_blank"
          rel="noopener noreferrer"
          className="smm-hero-cta"
        >
          Get Free Consultation
        </a>


        {/* TRUST POINTS */}

        <div className="smm-trust-points">

          <p>
            <span>01</span>
            Strategic content
          </p>

          <p>
            <span>02</span>
            Audience engagement
          </p>

          <p>
            <span>03</span>
            Lead-focused campaigns
          </p>

        </div>

      </div>

    </div>

  </div>
</section>


{/* SOCIAL MEDIA GAP */}

<section className="sm-gap-section">

  <div className="sm-gap-container">

    {/* HEADER */}
    <div className="sm-gap-header">

      <span className="sm-gap-label">
        THE SOCIAL MEDIA GAP
      </span>

      <h2>
        Being Active Doesn't Mean
        <br />
        <span>Being Effective.</span>
      </h2>

    </div>


    {/* COMPARISON */}
    <div className="sm-gap-comparison">


      {/* RANDOM SOCIAL MEDIA */}
      <div className="sm-gap-column sm-gap-random">

        <div className="sm-gap-column-top">
          <span className="sm-gap-number">
            01
          </span>

          <span className="sm-gap-category">
            RANDOM SOCIAL MEDIA
          </span>
        </div>

        <div className="sm-gap-heading">
          <h3>
            Posting without
            <br />
            <span>direction.</span>
          </h3>

          <p>
            Content becomes something you simply
            need to publish rather than something
            designed to move your business forward.
          </p>
        </div>


        <div className="sm-gap-points">

          <div className="sm-gap-point">
            <span>01</span>
            <p>Content without a clear objective</p>
          </div>

          <div className="sm-gap-point">
            <span>02</span>
            <p>Inconsistent brand messaging</p>
          </div>

          <div className="sm-gap-point">
            <span>03</span>
            <p>Chasing likes and followers</p>
          </div>

          <div className="sm-gap-point">
            <span>04</span>
            <p>No clear audience strategy</p>
          </div>

          <div className="sm-gap-point">
            <span>05</span>
            <p>Little connection to business goals</p>
          </div>

        </div>

      </div>



      {/* STRATEGIC SOCIAL MEDIA */}
      <div className="sm-gap-column sm-gap-strategic">

        <div className="sm-gap-column-top">
          <span className="sm-gap-number">
            02
          </span>

          <span className="sm-gap-category">
            STRATEGIC SOCIAL MEDIA
          </span>
        </div>

        <div className="sm-gap-heading">
          <h3>
            Every post has
            <br />
            <span>a purpose.</span>
          </h3>

          <p>
            Your content, audience, platforms, and
            campaigns work together around clear
            business objectives.
          </p>
        </div>


        <div className="sm-gap-points">

          <div className="sm-gap-point">
            <span>01</span>
            <p>Clear content direction</p>
          </div>

          <div className="sm-gap-point">
            <span>02</span>
            <p>Audience-focused messaging</p>
          </div>

          <div className="sm-gap-point">
            <span>03</span>
            <p>Consistent brand presence</p>
          </div>

          <div className="sm-gap-point">
            <span>04</span>
            <p>Content built around objectives</p>
          </div>

          <div className="sm-gap-point">
            <span>05</span>
            <p>Performance measured and improved</p>
          </div>

        </div>

      </div>

    </div>



    {/* CLOSING STATEMENT */}
    <div className="sm-gap-closing">

      <span className="sm-gap-closing-line"></span>

      <p>
        Your social media doesn't need
        <strong> more activity.</strong>
        It needs direction.
      </p>

    </div>

  </div>

</section>


{/* SOCIAL MEDIA SERVICES */}

<section className="sm-services-section">

  <div className="sm-services-container">

    {/* HEADER */}
    <div className="sm-services-header">

      <span className="sm-services-label">
        WHAT WE DO
      </span>

      <h2 className="visually-hidden">
  Social Media
  <br />
  <span>With Purpose.</span>
</h2>

      <p>
        Strategic social media services designed to build your presence,
        connect with the right audience, and support your business goals.
      </p>

    </div>


    {/* SERVICES LIST */}
    <div className="sm-services-list">


      {/* 01 */}
      <div className="sm-service-row">

        <span className="sm-service-number">
          01
        </span>

        <div className="sm-service-content">

          <h3>
            Social Media Strategy
          </h3>

          <p>
            Clear direction for what to say, who to reach, and what to achieve.
          </p>

        </div>

        <span className="sm-service-arrow">
          →
        </span>

      </div>


      {/* 02 */}
      <div className="sm-service-row">

        <span className="sm-service-number">
          02
        </span>

        <div className="sm-service-content">

          <h3>
            Content Creation
          </h3>

          <p>
            Professional graphics, captions, reels, and short-form content built around your brand.
          </p>

        </div>

        <span className="sm-service-arrow">
          →
        </span>

      </div>


      {/* 03 */}
      <div className="sm-service-row">

        <span className="sm-service-number">
          03
        </span>

        <div className="sm-service-content">

          <h3>
            Account Management
          </h3>

          <p>
            Consistent publishing, scheduling, optimisation, and day-to-day platform management.
          </p>

        </div>

        <span className="sm-service-arrow">
          →
        </span>

      </div>


      {/* 04 */}
      <div className="sm-service-row">

        <span className="sm-service-number">
          04
        </span>

        <div className="sm-service-content">

          <h3>
            Community Management
          </h3>

          <p>
            Meaningful interactions that help build trust and strengthen customer relationships.
          </p>

        </div>

        <span className="sm-service-arrow">
          →
        </span>

      </div>


      {/* 05 */}
      <div className="sm-service-row">

        <span className="sm-service-number">
          05
        </span>

        <div className="sm-service-content">

          <h3>
            Facebook & Instagram Ads
          </h3>

          <p>
            Targeted campaigns designed to reach potential customers and generate action.
          </p>

        </div>

        <span className="sm-service-arrow">
          →
        </span>

      </div>


      {/* 06 */}
      <div className="sm-service-row">

        <span className="sm-service-number">
          06
        </span>

        <div className="sm-service-content">

          <h3>
            Performance Tracking
          </h3>

          <p>
            Clear insights into what is working, what isn't, and where to improve.
          </p>

        </div>

        <span className="sm-service-arrow">
          →
        </span>

      </div>

    </div>


    {/* CLOSING */}
    <div className="sm-services-closing">

      <span className="sm-services-closing-line"></span>

      <p>
        Every post should have a purpose.
        <strong> Every campaign should have a reason.</strong>
      </p>

    </div>

  </div>

</section>

{/* =========================================================
    WHY CHOOSE SATIMA — SOCIAL MEDIA
========================================================= */}

<section className="social-why-section">

  <div className="social-why-container">

    {/* SECTION INTRO */}

    <div className="social-why-header">

      <span className="social-why-label">
        WHY CHOOSE SATIMA
      </span>

      <h2>
        Why Choose Satima for
        <br />
        Social Media Management
      </h2>

      <p>
        We manage social media with a clear understanding of your
        business, audience, content, and objectives.
      </p>

    </div>


    {/* MAIN CARD */}

    <div className="social-why-card">

      <div className="social-why-accent"></div>


      <div className="social-why-content">

        {/* STATEMENT */}

        <div className="social-why-statement">

          <span className="social-why-quote">
            “
          </span>

          <h3>
            Social Media.
            <br />
            <span>With Purpose.</span>
          </h3>

        </div>


        {/* MESSAGE */}

        <div className="social-why-message">

          <p>
            We believe social media should be more than
            <strong> regular posting.</strong> It should support
            your brand, connect with the right audience, and
            contribute to meaningful business goals.
          </p>


          {/* PRINCIPLES */}

          <div className="social-why-principles">

            <div className="social-why-principle">

              <span className="social-why-number">
                01
              </span>

              <div>
                <h4>
                  Strategy First
                </h4>

                <p>
                  We begin with your business objectives,
                  audience, and the role social media should play.
                </p>
              </div>

            </div>


            <div className="social-why-principle">

              <span className="social-why-number">
                02
              </span>

              <div>
                <h4>
                  Purposeful Content
                </h4>

                <p>
                  Every post has a reason, whether it is to educate,
                  build trust, showcase value, or encourage action.
                </p>
              </div>

            </div>


            <div className="social-why-principle">

              <span className="social-why-number">
                03
              </span>

              <div>
                <h4>
                  Performance Focused
                </h4>

                <p>
                  We pay attention to meaningful performance signals
                  so your social media can keep improving.
                </p>
              </div>

            </div>

          </div>


          {/* HIGHLIGHT */}

          <div className="social-why-highlight">

            <span className="social-why-highlight-line"></span>

            <p>
              Your social media doesn't need
              <strong> more activity.</strong>
              It needs a clear reason to exist.
            </p>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>


<section className="faq-section">

  <div className="faq-header">

    <h2>Frequently Asked Questions</h2>

    <p>
      Find answers to the most common questions about our social media
      management services for businesses in Kenya.
    </p>

  </div>


  <div className="faq-container">


    <details className="faq-item" open>

      <summary>
        How much does social media management cost?
      </summary>


      <p>
        We offer flexible monthly social media management packages designed
        for businesses with different goals and budgets.
      </p>


      <ul>

        <li>
          <strong>Basic Package:</strong> KSh 6,000 per month
        </li>


        <li>
          <strong>Premium Package:</strong> KSh 12,000 per month
        </li>

      </ul>


      <p>
        Every business has unique needs, so we can also recommend a customized
        social media strategy based on your objectives and growth targets.
      </p>


    </details>



    <details className="faq-item">

      <summary>
        What platforms do you manage?
      </summary>


      <p>
        We manage popular platforms including Facebook, Instagram, LinkedIn,
        and other social media channels depending on where your target audience
        spends their time.
      </p>


    </details>



    <details className="faq-item">

      <summary>
        What is included in your social media management service?
      </summary>


      <p>
        Our services may include content planning, graphic design, captions,
        post scheduling, audience engagement, page optimization, performance
        tracking, and ongoing strategy improvement.
      </p>


    </details>



    <details className="faq-item">

      <summary>
        How often will you post on my social media pages?
      </summary>


      <p>
        Posting frequency depends on your selected package and business goals.
        We create a consistent content schedule designed to keep your audience
        engaged while maintaining quality and brand consistency.
      </p>


    </details>



    <details className="faq-item">

      <summary>
        Do you also manage Facebook and Instagram advertising?
      </summary>


      <p>
        Yes. We create and manage Facebook and Instagram advertising campaigns
        designed to increase reach, generate leads, promote your services, and
        help your business reach potential customers.
      </p>


    </details>



    <details className="faq-item">

      <summary>
        How long does it take to see social media results?
      </summary>


      <p>
        Results depend on your industry, audience, content strategy, and
        advertising budget. While paid campaigns can generate results quickly,
        consistent organic growth requires ongoing strategy and optimization.
      </p>


    </details>



    <details className="faq-item">

      <summary>
        How do I get started with social media management?
      </summary>


      <p>
        Simply contact Satima Technova Solutions for a consultation. We will
        understand your business, review your current online presence, and
        recommend the best social media strategy for your goals.
      </p>


    </details>



  </div>

</section>




{/* =====================================
    FINAL CTA SECTION
===================================== */}

<section className="final-cta-section">

  <div className="final-cta-content">

    <span className="final-cta-label">
      READY TO MOVE FORWARD?
    </span>

    <h2>
  Make Social Media
  <br />
  <span>Work For You.</span>
</h2>

    <p>
      Let's build a focused social media strategy that
      connects your brand with the right audience.
    </p>

    <a
      href="https://wa.me/254775137928?text=Hi%20Satima%20Technova,%20I'm%20interested%20in%20your%20Social%20Media%20Management%20services."
      target="_blank"
      rel="noopener noreferrer"
      className="final-cta-btn"
      onClick={handleCTAClick}
    >
      Start A Conversation
      <span>→</span>
    </a>

  </div>

</section>  

      </main>
    </>
  );
};

export default SocialMediaManagement;